// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/store_cart/v1/store_cart.proto (package fingertip.creator.store_cart.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, StringValue } from "@bufbuild/protobuf";
import { StoreCartItem } from "../../../common/type/v1/store_cart_item_pb.js";
import { Media } from "../../../common/type/v1/media_pb.js";
import { StoreCart } from "../../../common/type/v1/store_cart_pb.js";
import { StoreCartDiscount } from "../../../common/type/v1/store_cart_discount_pb.js";
import { PaymentMethod } from "../../../common/type/v1/payment_method_pb.js";
import { Address } from "../../../common/type/v1/address_pb.js";
import { SiteContact } from "../../../common/type/v1/site_contact_pb.js";
import { StoreCoupon } from "../../../common/type/v1/store_coupon_pb.js";
import { StoreShippingRate } from "../../../common/type/v1/store_shipping_rate_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";

/**
 * @generated from message fingertip.creator.store_cart.v1.GetStoreCartPublicRequest
 */
export const GetStoreCartPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.GetStoreCartPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.CartItem
 */
export const CartItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.CartItem",
  () => [
    { no: 1, name: "cart_item", kind: "message", T: StoreCartItem },
    { no: 2, name: "product_media", kind: "message", T: Media },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.GetStoreCartPublicResponse
 */
export const GetStoreCartPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.GetStoreCartPublicResponse",
  () => [
    { no: 1, name: "cart", kind: "message", T: StoreCart },
    { no: 2, name: "cart_items", kind: "message", T: CartItem, repeated: true },
    { no: 3, name: "cart_discounts", kind: "message", T: StoreCartDiscount, repeated: true },
    { no: 4, name: "payment_method", kind: "message", T: PaymentMethod },
    { no: 5, name: "billing", kind: "message", T: Address },
    { no: 6, name: "site_contact", kind: "message", T: SiteContact },
    { no: 7, name: "coupon", kind: "message", T: StoreCoupon },
    { no: 8, name: "shipping", kind: "message", T: Address },
    { no: 9, name: "shipping_rate", kind: "message", T: StoreShippingRate },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.StoreCartContact
 */
export const StoreCartContact = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.StoreCartContact",
  () => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email_optin", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.CartAddress
 */
export const CartAddress = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.CartAddress",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_1", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "address_2", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.CartPaymentMethod
 */
export const CartPaymentMethod = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.CartPaymentMethod",
  () => [
    { no: 1, name: "stripe_payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.UpdateStoreCartPublicRequest
 */
export const UpdateStoreCartPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.UpdateStoreCartPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contact", kind: "message", T: StoreCartContact },
    { no: 4, name: "billing", kind: "message", T: CartAddress },
    { no: 5, name: "shipping", kind: "message", T: CartAddress },
    { no: 6, name: "payment_method", kind: "message", T: CartPaymentMethod },
    { no: 7, name: "shipping_rate_id", kind: "message", T: StringValue },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.UpdateStoreCartPublicResponse
 */
export const UpdateStoreCartPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.UpdateStoreCartPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.UpdateStoreCartCommentsPublicRequest
 */
export const UpdateStoreCartCommentsPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.UpdateStoreCartCommentsPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "comments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.UpdateStoreCartCommentsPublicResponse
 */
export const UpdateStoreCartCommentsPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.UpdateStoreCartCommentsPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.CartOptionItem
 */
export const CartOptionItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.CartOptionItem",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.AddStoreCartItemPublicRequest
 */
export const AddStoreCartItemPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.AddStoreCartItemPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "product_variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.AddStoreCartItemPublicResponse
 */
export const AddStoreCartItemPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.AddStoreCartItemPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.SetStoreCartTipPublicRequest
 */
export const SetStoreCartTipPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.SetStoreCartTipPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tip_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "tip_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.SetStoreCartTipPublicResponse
 */
export const SetStoreCartTipPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.SetStoreCartTipPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.UpdateStoreCartItemPublicRequest
 */
export const UpdateStoreCartItemPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.UpdateStoreCartItemPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cart_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.UpdateStoreCartItemPublicResponse
 */
export const UpdateStoreCartItemPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.UpdateStoreCartItemPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.RemoveStoreCartItemPublicRequest
 */
export const RemoveStoreCartItemPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.RemoveStoreCartItemPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cart_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.RemoveStoreCartItemPublicResponse
 */
export const RemoveStoreCartItemPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.RemoveStoreCartItemPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.EmptyStoreCartItemsPublicRequest
 */
export const EmptyStoreCartItemsPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.EmptyStoreCartItemsPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.EmptyStoreCartItemsPublicResponse
 */
export const EmptyStoreCartItemsPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.EmptyStoreCartItemsPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.GetStoreCartRequest
 */
export const GetStoreCartRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.GetStoreCartRequest",
  () => [
    { no: 1, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.GetStoreCartResponse
 */
export const GetStoreCartResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.GetStoreCartResponse",
  () => [
    { no: 1, name: "cart", kind: "message", T: StoreCart },
    { no: 2, name: "cart_items", kind: "message", T: CartItem, repeated: true },
    { no: 3, name: "cart_discounts", kind: "message", T: StoreCartDiscount, repeated: true },
    { no: 4, name: "payment_method", kind: "message", T: PaymentMethod },
    { no: 5, name: "billing", kind: "message", T: Address },
    { no: 6, name: "site_contact", kind: "message", T: SiteContact },
    { no: 7, name: "coupon", kind: "message", T: StoreCoupon },
    { no: 8, name: "shipping", kind: "message", T: Address },
    { no: 9, name: "shipping_rate", kind: "message", T: StoreShippingRate },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.GetStoreCartsRequest
 */
export const GetStoreCartsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.GetStoreCartsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.store_cart.v1.GetStoreCartsResponse
 */
export const GetStoreCartsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.store_cart.v1.GetStoreCartsResponse",
  () => [
    { no: 1, name: "carts", kind: "message", T: StoreCart, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

